<div class="step-progress font-work-sans">
  Step {{ currentStep }} of {{ totalSteps }}
</div>
